var jumpTo = require(24);
module.exports = function (ev) {
  ev.preventDefault();
  jumpTo($(ev.currentTarget).attr('href'), ev);
};
//# sourceMappingURL=handle-hash-change.js.map